module.exports = __webpack_public_path__ + "media/images/emoticons/catface-5c6a5ad237fd73a3b85084ea2fbe29ff.gif";